module.exports = __webpack_public_path__ + "static/media/stock.ace0b78c.svg";